export default {
      id: "oc-navbar-process-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-navbar-process",
      toString: function () {
        return this.url;
      }
    }